import { getWorkspaceId } from '../../lib/auth-storage';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { integrationApi, type WebhookSubscription } from '../../api/integration';

export function WebhookManagerPage() {
  const [webhooks, setWebhooks] = useState<WebhookSubscription[]>([]);
  const [url, setUrl] = useState('');
  const [events, setEvents] = useState('order.created,inventory.updated');
  const [error, setError] = useState('');

  const refresh = () => {
    void integrationApi.listWebhookSubscriptions((getWorkspaceId() ?? '')).then(setWebhooks).catch((e) => setError(String(e)));
  };

  useEffect(() => { refresh(); }, []);

  const register = async () => {
    if (!url.trim()) return;
    try {
      await integrationApi.createWebhookSubscription({
        url: url.trim(),
        events: events.split(',').map((e) => e.trim()).filter(Boolean),
      });
      setUrl('');
      refresh();
    } catch (e) {
      setError(String(e));
    }
  };

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Webhook Manager</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Register, verify, retry and monitor webhook subscriptions.</p>
      <Link to="/integrations" className="mt-2 inline-block text-sm text-teal-700 hover:underline dark:text-teal-400">← Integration Hub</Link>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 rounded-xl border p-4 dark:border-slate-700">
        <h2 className="font-medium">Register Webhook</h2>
        <div className="mt-3 space-y-2">
          <input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://your-app.com/webhooks" className="w-full rounded border px-3 py-2 text-sm dark:border-slate-600 dark:bg-slate-800" />
          <input value={events} onChange={(e) => setEvents(e.target.value)} placeholder="Events (comma-separated)" className="w-full rounded border px-3 py-2 text-sm dark:border-slate-600 dark:bg-slate-800" />
          <button type="button" onClick={register} className="rounded bg-teal-600 px-4 py-2 text-sm text-white hover:bg-teal-700">Register</button>
        </div>
      </div>
      <div className="mt-8">
        <h2 className="font-medium">Subscriptions ({webhooks.length})</h2>
        <ul className="mt-3 space-y-2">
          {webhooks.map((w) => (
            <li key={w.id} className="rounded border px-4 py-3 text-sm dark:border-slate-700">
              <p className="font-mono text-xs break-all">{w.url}</p>
              <p className="mt-1 text-slate-500">{w.events?.join(', ') || 'all events'} · {w.active ? 'active' : 'inactive'}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
